import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useRouter } from 'next/router';
import { LoaderScreen } from '@grandvisionhq/common';
import { useDispatch } from '@grandvisionhq/state';
import { useTealiumEventProperties, useTrackPageView } from '@grandvisionhq/svc-tealium/events';
import { logSignInEvent } from '../data-layer/sign-in.js';
import { useSocialLoginMethod } from '../hooks/use-social-login-method.js';
import { loggedOut } from '../Logout/actions.js';
import { parseHash } from './actions.js';

const Callback = ({ type  })=>{
    const dispatch = useDispatch();
    const { asPath: callbackReturnPath , query  } = useRouter();
    const { handleSocialLogin  } = useSocialLoginMethod();
    const { commonEventProperties , getCommonUserProperties  } = useTealiumEventProperties();
    const loginPageView = React.useCallback(swcHelpers.asyncToGenerator(function*() {
        const commonUserProperties = yield getCommonUserProperties;
        return swcHelpers.objectSpread({
            id: 'VirtualPage-View',
            Page_Section1: 'Account',
            Page_Type: 'Static',
            Page_Design: 'Login'
        }, commonEventProperties, commonUserProperties);
    }), [
        commonEventProperties,
        getCommonUserProperties
    ]);
    useTrackPageView(loginPageView);
    React.useEffect(()=>{
        if (query.loginMethod === 'social') {
            handleSocialLogin();
        } else {
            if (type === 'callback') {
                dispatch(parseHash());
                logSignInEvent();
            }
            if (type === 'logged-out') {
                dispatch(loggedOut(callbackReturnPath));
            }
        }
    }, [
        callbackReturnPath,
        dispatch,
        handleSocialLogin,
        query.loginMethod,
        type
    ]);
    return /*#__PURE__*/ React.createElement(LoaderScreen, {
        height: 50
    });
};
var Callback$1 = Callback;

export { Callback$1 as default };
//# sourceMappingURL=Callback.js.map
